export const FEATURES = {
  AVG_WHEELS: "AVG_WHEELS", //how many wheels can be created
  SPACE_ALLOCATED: "SPACE_ALLOCATED", //how much space is allocated
  MESSAGING: "MESSAGING",
  REFFERAL_PROGRAM: "REFFERAL_PROGRAM",
  ANALYTICS: "ANALYTICS",
  BUSINESS_BOX: "BUSINESS_BOX",
  SEO: "SEO",
  WHEEL_WALLPAPER_IMAGE: "IMAGES", // can upload wallpaper image
  SHORTCUT_HOTBAR: "SHORTCUT_HOTBAR",
  // Gate for the segment/wheel color-palette generator. This IS the real BE
  // feature code (subscription/enums.py FeatureType.ADV_PALLETE_GENERATOR,
  // AdvPalleteGenerator permission, permissions.py:401-406) — every palette
  // entry point (WheelPaletteTab, DesignTab, SegmentColor, CreateWheelPopup,
  // and now Shared/ColorPalette) must gate on THIS key.
  ADV_PALLETE_GENERATOR: "ADV_PALLETE_GENERATOR",
  // D-16 (TIER-MATRIX.md): a prior fix here defined a self-referential
  // COLOR_PALETTE: "COLOR_PALETTE" key to stop Shared/ColorPalette's gate
  // failing OPEN on an undefined feature. That key fires the eligibility
  // query but matches no real BE FeatureType — and PermissionCheckViewSet
  // returns allowed:True for ANY unmapped feature (fails OPEN, not closed),
  // so the partial fix left the paywall bypassed for every tier, the same
  // bug as the undefined-key state it replaced. Removed —
  // Shared/ColorPalette now points at the real ADV_PALLETE_GENERATOR key
  // above. Do not re-add a feature key here unless it matches an actual BE
  // subscription/enums.py FeatureType value; the sweep test in
  // featureKeys.sweep.test.js only checks the key EXISTS here, not that it's
  // BE-real — that check is manual.
  CUSTOM_HEX_COLORS: "C_HEX_COLORS",
  // Flag-gated WCAG-AA contrast guard on palette + custom-hex entry (audit B-19).
  // Warn-only and OFF by default so it cannot alter the running app's behavior
  // until explicitly enabled; gated through the same eligibility/flag plumbing.
  WCAG_CONTRAST_GUARD: "WCAG_CONTRAST_GUARD",
  TEMPLATE: "TEMPLATE",
  LOCKABLE_WHEELS: "LOCKABLE_WHEELS", //can lock wheels
  CLONING_WHEELS: "CLONING_WHEELS", //how many wheels can be cloned
  CLONING_STORAGE: "CLONING_STORAGE", //how many clones can be stored
  AI_CS_CHAT: "AI_CS_CHAT",
  AI_TEXT_SUGGESTIONS: "AI_TEXT_SUGGESTIONS",
  AI_WHEEL_GENERATOR: "AI_WHEEL_GENERATOR",
  TEXT_ONLY: "TEXT_ONLY",
  UPLOAD_VIDEOS: "UPLOAD_VIDEO",
  PALETTE_AI_TEXT: "PALETTE_AI_TEXT", //can generate palette from text
  PALETTE_AI_IMAGE: "PALETTE_AI_IMAGE", //can generate palette from image
  AI_MEDIA_UPLOADS: "MEDIA_UPLOAD",
};